module.exports = __webpack_public_path__ + "static/media/frame.b5049090.png";